export const CLUB_RETURN_PATH_KEY = 'replayerClubReturnPath';
export const CLUB_PENDING_ACTION_KEY = 'replayerClubPendingAction';
export const CLUB_AUTHENTICATED_PATH_KEY = 'replayerAuthenticatedClubPath';
export const CLUB_PENDING_BOOKING_SLOT_KEY = 'replayerClubPendingBookingSlot';
export const CLUB_BOOKING_SAVED_EVENT = 'replayer-club-booking-saved';
export const CLUB_MODE_CHANGED_EVENT = 'replayer-club-auth-changed';

export const getClubPath = key => {
  if (typeof window === 'undefined') return null;
  const path = window.sessionStorage.getItem(key);
  return typeof path === 'string' && path.startsWith('/club/') && !path.startsWith('//')
    ? path
    : null;
};

export const getActiveClubPath = () => getClubPath(CLUB_AUTHENTICATED_PATH_KEY);

export const navigateToAuthenticatedPlayerFlow = ({
  navigate,
  onAuthenticated,
  path,
  remember,
  token
}) => {
  remember();
  if (!token) {
    navigate(`/login?next=${encodeURIComponent(path)}`);
    return false;
  }

  if (onAuthenticated) {
    onAuthenticated();
  }
  navigate(path);
  return true;
};

export const activateClubMode = path => {
  if (typeof window === 'undefined' || !path || !path.startsWith('/club/') || path.startsWith('//')) {
    return;
  }
  window.sessionStorage.setItem(CLUB_AUTHENTICATED_PATH_KEY, path);
  window.sessionStorage.setItem(CLUB_RETURN_PATH_KEY, path);
  window.dispatchEvent(new Event(CLUB_MODE_CHANGED_EVENT));
};

export const clearClubMode = () => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(CLUB_AUTHENTICATED_PATH_KEY);
  window.sessionStorage.removeItem(CLUB_RETURN_PATH_KEY);
  window.sessionStorage.removeItem(CLUB_PENDING_BOOKING_SLOT_KEY);
  window.dispatchEvent(new Event(CLUB_MODE_CHANGED_EVENT));
};
